angular.module('octopusApp.projects')
    .config(function($stateProvider,$urlRouterProvider) {

        $stateProvider.state('app.projects.groups', {
            abstract: true,
            url: '^/projectgroups',
            template: '<script octo-section="breadcrumbs" type="text/ng-template"><li>Project Groups</li></script><ui-view></ui-view>'
        });

        $stateProvider.state('app.projects.groups.new', {
            url: '/new',
            templateUrl: 'areas/projects/groups/ProjectGroupCreate.html',
            controller: 'ProjectGroupEditController',
            layout: {
                title: 'New Project Group'
            }
        });


        $stateProvider.state('app.projects.groups.edit', {
            url: '/:id',
            templateUrl: 'areas/projects/groups/ProjectGroupEdit.html',
            controller: 'ProjectGroupEditController',
            layout: {
                title: 'Edit Project Group'
            }
        });
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/groups/routes.js
// module id = 6560575094290579
// module chunks = 1